var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { getAccessTokenSilentlyWithProviderDefaults } from '../utils/auth0SilentToken';
import { isAdmin } from '../auth/auth0-config';
import { setSupportContactOverride } from '../utils/envUtils';
var defaultSettings = {
    maintenanceMode: {
        enabled: false,
        message: "We're currently performing scheduled maintenance.",
        allowAdminAccess: true,
        estimatedEndTime: null
    },
    allowManagerAccess: true,
    holidayGreetingsEnabled: true,
    billing: {
        squareDailyLocationId: null,
        squareMonthlyLocationId: null,
        updatedAt: null
    },
    contact: {
        businessName: null,
        supportEmail: null,
        supportPhone: null,
        address: {
            line1: null,
            line2: null,
            city: null,
            state: null,
            postalCode: null,
            country: 'US',
        },
        updatedAt: null
    },
    socialLinks: {
        instagram: null,
        facebook: null,
        updatedAt: null
    },
    branding: {
        headerLogoUrl: null,
        faviconUrl: null,
        headerLogoAltText: 'Truck Parking Hub logo',
        headerBrandPrimaryText: 'Truck Parking',
        headerBrandSecondaryText: 'Hub',
        updatedAt: null
    },
    appearance: {
        accent: 'amber',
        fontFamily: 'dm-sans',
        brandFontFamily: 'default',
        fontSize: 'default',
        hubColor: '#E10600',
    },
};
var SiteSettingsContext = createContext(undefined);
// Resolve API base URL
var resolveApiBaseUrl = function () {
    if (process.env.REACT_APP_TPH_CONTINUITY_CHECKOUT === 'true')
        return '';
    var envApiUrl = process.env.REACT_APP_API_URL;
    if (envApiUrl && typeof envApiUrl === 'string' && envApiUrl.trim().length > 0) {
        return envApiUrl.trim().replace(/\/$/, '');
    }
    var railwayApiUrl = process.env.REACT_APP_API_URL_RAILWAY;
    if (railwayApiUrl && typeof railwayApiUrl === 'string' && railwayApiUrl.trim().length > 0) {
        return railwayApiUrl.trim().replace(/\/$/, '');
    }
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return "http://".concat(window.location.hostname, ":5050");
        }
        return window.location.origin.replace(/\/$/, '');
    }
    return 'https://www.trucksparkinghub.com';
};
var API_BASE_URL = resolveApiBaseUrl();
var DEFAULT_AUTH_BRIDGE = {
    user: null,
    isAuthenticated: false,
    getAccessTokenSilently: undefined,
};
var normalizeSiteSettings = function (settings) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41;
    return ({
        maintenanceMode: {
            enabled: (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : defaultSettings.maintenanceMode.enabled,
            message: ((_c = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _c === void 0 ? void 0 : _c.message) || defaultSettings.maintenanceMode.message,
            allowAdminAccess: (_e = (_d = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _d === void 0 ? void 0 : _d.allowAdminAccess) !== null && _e !== void 0 ? _e : defaultSettings.maintenanceMode.allowAdminAccess,
            estimatedEndTime: (_g = (_f = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _f === void 0 ? void 0 : _f.estimatedEndTime) !== null && _g !== void 0 ? _g : defaultSettings.maintenanceMode.estimatedEndTime,
        },
        allowManagerAccess: (_h = settings === null || settings === void 0 ? void 0 : settings.allowManagerAccess) !== null && _h !== void 0 ? _h : defaultSettings.allowManagerAccess,
        holidayGreetingsEnabled: (_j = settings === null || settings === void 0 ? void 0 : settings.holidayGreetingsEnabled) !== null && _j !== void 0 ? _j : defaultSettings.holidayGreetingsEnabled,
        billing: {
            squareDailyLocationId: (_l = (_k = settings === null || settings === void 0 ? void 0 : settings.billing) === null || _k === void 0 ? void 0 : _k.squareDailyLocationId) !== null && _l !== void 0 ? _l : defaultSettings.billing.squareDailyLocationId,
            squareMonthlyLocationId: (_o = (_m = settings === null || settings === void 0 ? void 0 : settings.billing) === null || _m === void 0 ? void 0 : _m.squareMonthlyLocationId) !== null && _o !== void 0 ? _o : defaultSettings.billing.squareMonthlyLocationId,
            updatedAt: (_q = (_p = settings === null || settings === void 0 ? void 0 : settings.billing) === null || _p === void 0 ? void 0 : _p.updatedAt) !== null && _q !== void 0 ? _q : defaultSettings.billing.updatedAt
        },
        contact: {
            businessName: (_s = (_r = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _r === void 0 ? void 0 : _r.businessName) !== null && _s !== void 0 ? _s : defaultSettings.contact.businessName,
            supportEmail: (_u = (_t = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _t === void 0 ? void 0 : _t.supportEmail) !== null && _u !== void 0 ? _u : defaultSettings.contact.supportEmail,
            supportPhone: (_w = (_v = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _v === void 0 ? void 0 : _v.supportPhone) !== null && _w !== void 0 ? _w : defaultSettings.contact.supportPhone,
            address: {
                line1: (_z = (_y = (_x = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _x === void 0 ? void 0 : _x.address) === null || _y === void 0 ? void 0 : _y.line1) !== null && _z !== void 0 ? _z : defaultSettings.contact.address.line1,
                line2: (_2 = (_1 = (_0 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _0 === void 0 ? void 0 : _0.address) === null || _1 === void 0 ? void 0 : _1.line2) !== null && _2 !== void 0 ? _2 : defaultSettings.contact.address.line2,
                city: (_5 = (_4 = (_3 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _3 === void 0 ? void 0 : _3.address) === null || _4 === void 0 ? void 0 : _4.city) !== null && _5 !== void 0 ? _5 : defaultSettings.contact.address.city,
                state: (_8 = (_7 = (_6 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _6 === void 0 ? void 0 : _6.address) === null || _7 === void 0 ? void 0 : _7.state) !== null && _8 !== void 0 ? _8 : defaultSettings.contact.address.state,
                postalCode: (_11 = (_10 = (_9 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _9 === void 0 ? void 0 : _9.address) === null || _10 === void 0 ? void 0 : _10.postalCode) !== null && _11 !== void 0 ? _11 : defaultSettings.contact.address.postalCode,
                country: (_14 = (_13 = (_12 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _12 === void 0 ? void 0 : _12.address) === null || _13 === void 0 ? void 0 : _13.country) !== null && _14 !== void 0 ? _14 : defaultSettings.contact.address.country,
            },
            updatedAt: (_16 = (_15 = settings === null || settings === void 0 ? void 0 : settings.contact) === null || _15 === void 0 ? void 0 : _15.updatedAt) !== null && _16 !== void 0 ? _16 : defaultSettings.contact.updatedAt
        },
        socialLinks: {
            instagram: (_18 = (_17 = settings === null || settings === void 0 ? void 0 : settings.socialLinks) === null || _17 === void 0 ? void 0 : _17.instagram) !== null && _18 !== void 0 ? _18 : defaultSettings.socialLinks.instagram,
            facebook: (_20 = (_19 = settings === null || settings === void 0 ? void 0 : settings.socialLinks) === null || _19 === void 0 ? void 0 : _19.facebook) !== null && _20 !== void 0 ? _20 : defaultSettings.socialLinks.facebook,
            updatedAt: (_22 = (_21 = settings === null || settings === void 0 ? void 0 : settings.socialLinks) === null || _21 === void 0 ? void 0 : _21.updatedAt) !== null && _22 !== void 0 ? _22 : defaultSettings.socialLinks.updatedAt
        },
        branding: {
            headerLogoUrl: (_24 = (_23 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _23 === void 0 ? void 0 : _23.headerLogoUrl) !== null && _24 !== void 0 ? _24 : defaultSettings.branding.headerLogoUrl,
            faviconUrl: (_26 = (_25 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _25 === void 0 ? void 0 : _25.faviconUrl) !== null && _26 !== void 0 ? _26 : defaultSettings.branding.faviconUrl,
            headerLogoAltText: ((_27 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _27 === void 0 ? void 0 : _27.headerLogoAltText) || defaultSettings.branding.headerLogoAltText,
            headerBrandPrimaryText: ((_28 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _28 === void 0 ? void 0 : _28.headerBrandPrimaryText) || defaultSettings.branding.headerBrandPrimaryText,
            headerBrandSecondaryText: ((_29 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _29 === void 0 ? void 0 : _29.headerBrandSecondaryText) || defaultSettings.branding.headerBrandSecondaryText,
            updatedAt: (_31 = (_30 = settings === null || settings === void 0 ? void 0 : settings.branding) === null || _30 === void 0 ? void 0 : _30.updatedAt) !== null && _31 !== void 0 ? _31 : defaultSettings.branding.updatedAt
        },
        appearance: {
            accent: (_33 = (_32 = settings === null || settings === void 0 ? void 0 : settings.appearance) === null || _32 === void 0 ? void 0 : _32.accent) !== null && _33 !== void 0 ? _33 : defaultSettings.appearance.accent,
            fontFamily: (_35 = (_34 = settings === null || settings === void 0 ? void 0 : settings.appearance) === null || _34 === void 0 ? void 0 : _34.fontFamily) !== null && _35 !== void 0 ? _35 : defaultSettings.appearance.fontFamily,
            brandFontFamily: (_37 = (_36 = settings === null || settings === void 0 ? void 0 : settings.appearance) === null || _36 === void 0 ? void 0 : _36.brandFontFamily) !== null && _37 !== void 0 ? _37 : defaultSettings.appearance.brandFontFamily,
            fontSize: (_39 = (_38 = settings === null || settings === void 0 ? void 0 : settings.appearance) === null || _38 === void 0 ? void 0 : _38.fontSize) !== null && _39 !== void 0 ? _39 : defaultSettings.appearance.fontSize,
            hubColor: (_41 = (_40 = settings === null || settings === void 0 ? void 0 : settings.appearance) === null || _40 === void 0 ? void 0 : _40.hubColor) !== null && _41 !== void 0 ? _41 : defaultSettings.appearance.hubColor,
        },
        updatedAt: settings === null || settings === void 0 ? void 0 : settings.updatedAt,
        updatedBy: settings === null || settings === void 0 ? void 0 : settings.updatedBy,
    });
};
export var SiteSettingsProvider = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, auth = _a.auth;
    var authBridge = auth !== null && auth !== void 0 ? auth : DEFAULT_AUTH_BRIDGE;
    var _f = useState(null), settings = _f[0], setSettings = _f[1];
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState(null), error = _h[0], setError = _h[1];
    var fetchSettingsInFlightRef = useRef(null);
    var authRefreshRequestedRef = useRef(false);
    var userIsAdmin = Boolean(authBridge.isAuthenticated && authBridge.user && isAdmin(authBridge.user));
    var isMaintenanceMode = (_c = (_b = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : false;
    var canBypassMaintenance = userIsAdmin && ((_e = (_d = settings === null || settings === void 0 ? void 0 : settings.maintenanceMode) === null || _d === void 0 ? void 0 : _d.allowAdminAccess) !== null && _e !== void 0 ? _e : true);
    // Fetch public settings (no auth required)
    var fetchSettings = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestPromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (fetchSettingsInFlightRef.current) {
                        return [2 /*return*/, fetchSettingsInFlightRef.current];
                    }
                    requestPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                        var response, result, err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, 4, 5]);
                                    setLoading(true);
                                    setError(null);
                                    return [4 /*yield*/, fetch("".concat(API_BASE_URL, "/api/site-settings"))];
                                case 1:
                                    response = _a.sent();
                                    if (!response.ok) {
                                        throw new Error('Failed to fetch site settings');
                                    }
                                    return [4 /*yield*/, response.json()];
                                case 2:
                                    result = _a.sent();
                                    if (result.success && result.data) {
                                        setSettings(normalizeSiteSettings(result.data));
                                    }
                                    else {
                                        setSettings(defaultSettings);
                                    }
                                    return [3 /*break*/, 5];
                                case 3:
                                    err_1 = _a.sent();
                                    console.error('[SiteSettings] Error fetching settings:', err_1);
                                    setError(err_1 instanceof Error ? err_1.message : 'Unknown error');
                                    // Use defaults on error to not block the app
                                    setSettings(defaultSettings);
                                    return [3 /*break*/, 5];
                                case 4:
                                    setLoading(false);
                                    return [7 /*endfinally*/];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); })();
                    fetchSettingsInFlightRef.current = requestPromise;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, requestPromise];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (fetchSettingsInFlightRef.current === requestPromise) {
                        fetchSettingsInFlightRef.current = null;
                    }
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    // Update settings (admin only)
    var updateSettings = useCallback(function (updates) { return __awaiter(void 0, void 0, void 0, function () {
        var token, response, result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!userIsAdmin) {
                        console.error('[SiteSettings] Update denied - not admin');
                        return [2 /*return*/, false];
                    }
                    if (!authBridge.getAccessTokenSilently) {
                        console.error('[SiteSettings] Update denied - auth bridge token provider unavailable');
                        return [2 /*return*/, false];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, getAccessTokenSilentlyWithProviderDefaults(authBridge.getAccessTokenSilently, {
                            authorizationParams: {
                                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                                scope: 'openid profile email'
                            }
                        })];
                case 2:
                    token = _a.sent();
                    return [4 /*yield*/, fetch("".concat(API_BASE_URL, "/api/site-settings/admin"), {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': "Bearer ".concat(token)
                            },
                            body: JSON.stringify(updates)
                        })];
                case 3:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Failed to update settings');
                    }
                    return [4 /*yield*/, response.json()];
                case 4:
                    result = _a.sent();
                    if (result.success && result.data) {
                        setSettings(normalizeSiteSettings(result.data));
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 5:
                    err_2 = _a.sent();
                    console.error('[SiteSettings] Error updating settings:', err_2);
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [authBridge, userIsAdmin]);
    // Quick toggle for maintenance mode
    var toggleMaintenance = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, response, result_1, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!userIsAdmin) {
                        console.error('[SiteSettings] Toggle denied - not admin');
                        return [2 /*return*/, false];
                    }
                    if (!authBridge.getAccessTokenSilently) {
                        console.error('[SiteSettings] Toggle denied - auth bridge token provider unavailable');
                        return [2 /*return*/, false];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, getAccessTokenSilentlyWithProviderDefaults(authBridge.getAccessTokenSilently, {
                            authorizationParams: {
                                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                                scope: 'openid profile email'
                            }
                        })];
                case 2:
                    token = _a.sent();
                    return [4 /*yield*/, fetch("".concat(API_BASE_URL, "/api/site-settings/admin/maintenance/toggle"), {
                            method: 'POST',
                            headers: {
                                'Authorization': "Bearer ".concat(token)
                            }
                        })];
                case 3:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Failed to toggle maintenance');
                    }
                    return [4 /*yield*/, response.json()];
                case 4:
                    result_1 = _a.sent();
                    if (result_1.success && result_1.data) {
                        setSettings(function (prev) { return prev ? __assign(__assign({}, prev), { maintenanceMode: result_1.data.maintenanceMode }) : null; });
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 5:
                    err_3 = _a.sent();
                    console.error('[SiteSettings] Error toggling maintenance:', err_3);
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [authBridge, userIsAdmin]);
    // Fetch settings on mount
    useEffect(function () {
        fetchSettings();
    }, [fetchSettings]);
    // Keep envUtils' support contact override in sync with admin-configured settings
    useEffect(function () {
        setSupportContactOverride(settings === null || settings === void 0 ? void 0 : settings.contact);
    }, [settings === null || settings === void 0 ? void 0 : settings.contact]);
    // Optionally refetch once when auth transitions to authenticated.
    useEffect(function () {
        if (!authBridge.isAuthenticated) {
            authRefreshRequestedRef.current = false;
            return;
        }
        if (!authRefreshRequestedRef.current) {
            authRefreshRequestedRef.current = true;
            fetchSettings();
        }
    }, [authBridge.isAuthenticated, fetchSettings]);
    var value = {
        settings: settings,
        loading: loading,
        error: error,
        isMaintenanceMode: isMaintenanceMode,
        canBypassMaintenance: canBypassMaintenance,
        refetch: fetchSettings,
        updateSettings: updateSettings,
        toggleMaintenance: toggleMaintenance
    };
    return (_jsx(SiteSettingsContext.Provider, __assign({ value: value }, { children: children })));
};
export var useSiteSettings = function () {
    var context = useContext(SiteSettingsContext);
    if (context === undefined) {
        throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
    }
    return context;
};
export var useOptionalSiteSettings = function () {
    var _a;
    return (_a = useContext(SiteSettingsContext)) !== null && _a !== void 0 ? _a : null;
};
export default SiteSettingsContext;
